


import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling

function Effective_Geospatial_Collaboration() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div className="pdf-page">
  <iframe
    src={t('SLA_DOC')}
    title="PDF Document"
  />
</div>

  );
};

export default Effective_Geospatial_Collaboration;
